import {useNavigate} from 'react-router-dom';

export const SET_ELEMENTS_CLICKED = 'SET_ELEMENTS_CLICKED';
export const CLEAR_ELEMENT_CLICKED = 'CLEAR_ELEMENT_CLICKED';
export const HANDLE_ELEMENTS_CLICKED = 'HANDLE_ELEMENTS_CLICKED';
export const CLOCK_TICK = 'CLOCK_TICK';
export const END_PRESENTATION = 'END_PRESENTATION';
export const OPEN_ASK_TO_END_PRESENTATION = 'OPEN_ASK_TO_END_PRESENTATION';
export const CLOSE_ASK_TO_END_PRESENTATION = 'CLOSE_ASK_TO_END_PRESENTATION';

export interface ISetElementsClickedAction {
    type: typeof SET_ELEMENTS_CLICKED;
    payload: string[];
}

export interface IClearElementClickedAction {
    type: typeof CLEAR_ELEMENT_CLICKED;
}

export interface IOpenEndPresentationAction {
    type: typeof OPEN_ASK_TO_END_PRESENTATION;
}

export interface ICloseEndPresentationAction {
    type: typeof CLOSE_ASK_TO_END_PRESENTATION;
}

export interface IEndPresentationAction {
    type: typeof END_PRESENTATION;
    payload: ReturnType<typeof useNavigate>;
}

export interface IClockTickAction {
    type: typeof CLOCK_TICK;
}
